/**
 * Shared header for every public storefront page.
 *
 * Brand mark on the left, language toggle + tiny "Sign in" link on the
 * right. Purely presentational — no business logic.
 */
import { Link } from 'react-router-dom';

import { useLang } from '@/i18n/useLang';

export function StorefrontHeader() {
  const { lang, setLang } = useLang();
  return (
    <header className="border-b border-stone-800/60 bg-stone-950/80 backdrop-blur">
      <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-3 lg:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="rounded-md bg-saffron-700/40 px-2 py-1 text-xs font-bold uppercase tracking-wider text-saffron-100">
            {lang === 'hi' ? 'ज्योतिष' : 'Astro'}
          </span>
          <span className="text-sm font-semibold text-stone-100">
            {lang === 'hi'
              ? 'इंस्टीट्यूट ऑफ़ फ़ाइनेंशियल स्टडीज़'
              : 'Institute of Financial Studies'}
          </span>
        </Link>
        <div className="flex items-center gap-3 text-xs">
          <button
            type="button"
            onClick={() => setLang(lang === 'hi' ? 'en' : 'hi')}
            className="rounded-md border border-saffron-600 bg-stone-950 px-2 py-1 text-saffron-200 hover:bg-saffron-700/30"
            aria-label={lang === 'hi' ? 'Switch to English' : 'हिन्दी'}
          >
            {lang === 'hi' ? 'EN' : 'हिं'}
          </button>
          <Link
            to="/workbench"
            className="text-stone-400 hover:text-saffron-200"
          >
            {lang === 'hi' ? 'प्रवेश' : 'Sign in'}
          </Link>
        </div>
      </div>
    </header>
  );
}
